// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabs_wrapper__p0P9O","tab":"Tabs_tab__Tzmv-","selected":"Tabs_selected__tKzwd","active":"Tabs_active__h6mRZ","inactive":"Tabs_inactive__VJRaz"};